<div class="container-fluid d-flex p-0 litigation-complaints-container">
  <app-side-bar></app-side-bar>
  <ng-container>
    <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
      <div class="main-heading">
        <h1>Get Most Searched Products</h1>
      </div>

      <!-- <button (click)="refreshData()" class="btn btn-primary" style="margin-bottom: 10px;">
        Refresh Data
      </button> -->

      <div class="card">
        <p-table [value]="filteredLitigationData" [lazy]="true" (onLazyLoad)="loadLitigationDataLazy($event)"
          [totalRecords]="totalRecords" [loading]="loading" [paginator]="true" [rows]="10"
          [rowsPerPageOptions]="[10, 50, 100]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [scrollable]="true"
          [tableStyle]="{ 'min-width': '60rem' }">
          <ng-template pTemplate="paginatorleft">
            <div style="width: 100%; text-align: center; font-weight: 500;">
              Total Records: {{ totalRecords }}
            </div>
          </ng-template>
          <ng-template #customPaginator let-state>
            <div style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
          ">
              <div style="font-weight: 500; margin-bottom: 4px;">
                Total Records: {{ totalRecords }}
              </div>
              <div style="display: flex; align-items: center;">
                <button pButton type="button" icon="pi pi-angle-double-left" (click)="state.changePageToFirst($event)"
                  [disabled]="state.page === 0" class="p-button-text"></button>
                <button pButton type="button" icon="pi pi-angle-left" (click)="state.changePageToPrev($event)"
                  [disabled]="state.page === 0" class="p-button-text"></button>
                <span style="margin: 0 10px;">Page {{ state.page + 1 }} of {{ state.totalPages }}</span>
                <button pButton type="button" icon="pi pi-angle-right" (click)="state.changePageToNext($event)"
                  [disabled]="state.page >= state.totalPages - 1" class="p-button-text"></button>
                <button pButton type="button" icon="pi pi-angle-double-right" (click)="state.changePageToLast($event)"
                  [disabled]="state.page >= state.totalPages - 1" class="p-button-text"></button>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="caption">
            <div class="flex" style="display: flex; justify-content: flex-start; gap: 10px;">
              <p-dropdown [filter]="true" [options]="dropdownOptions" [(ngModel)]="selectedOption" (onChange)="onOptionChange($event)">
              </p-dropdown>

                <p-dropdown  [filter]="true" [options]="dropdownUserOptions" [(ngModel)]="selectedUserOption" (onChange)="onOptionUserChange($event)">
              </p-dropdown>
             
              <!-- <input pInputText type="text" [(ngModel)]="caseNumberSearch" (ngModelChange)="onCaseNumberChange($event)"
                placeholder="Search by Case Number" />
              <input pInputText type="text" [(ngModel)]="plaintiffSearch" (ngModelChange)="onPlaintiffChange($event)"
                placeholder="Search by Plaintiff" />
              <input pInputText type="text" [(ngModel)]="defendantSearch" (ngModelChange)="onDefendantChange($event)"
                placeholder="Search by Defendant" />
              <input pInputText type="text" [(ngModel)]="courtNameSearch" (ngModelChange)="onCourtNameChange($event)"
                placeholder="Search by Court Name" /> -->

                <button pButton type="button" icon="pi" (click)="clearSearch()"
                style="display: flex; justify-content: flex-end; gap: 10px;align-items: center;">
                  Clear 
                </button>
                
              <span class="p-input-icon-left ml-auto"
                style="display: flex; justify-content: flex-end; gap: 10px;align-items: center;">
                <input pInputText type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
                placeholder="Search" />
                <!-- <span style="margin-right: 10px;">Total Records : {{ totalRecords }}</span> -->
              </span>
            </div>
            <p *ngIf="dateError" style="color: red; margin-top: 5px;text-align: center;
">
              {{ dateError }}
            </p>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
                <th>
                  <span class="header-container">Nda number</span>
                </th>
              <th>
                <span class="header-container">Brand Name</span>
              </th>
              <th>
                <span class="header-container">Email</span>
              </th>
               <th>
                <span class="header-container">Comapny</span>
              </th>
              
              <th>
                <span class="header-container">Searched Date</span>
              </th>
              <th>
                <span class="header-container">Searched Time</span>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData['nda_number'] || 'N/A' }}</td>
              <td>{{ rowData['brand_name'] || 'N/A' }}</td>
              <td>{{ rowData['email'] || 'N/A' }}</td>
              <td>{{ rowData['company_name'] || 'N/A' }}</td>
              <td>{{ rowData['searched_date'] || 'N/A' }}</td>

              
              <td>{{ rowData['searched_time'] || 'N/A' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>
</div>